import React, { useCallback, useState, useMemo ,useEffect} from "react";
import { useLocation ,useHistory ,useParams} from "react-router-dom";
import Request from "@/networkReq/request";
import Http from "@/networkReq/http";
import {
  Card,
  Form,
  Tag,
  Upload,
  Button,
  Input,
  Col,
  Row,
  message,
} from "antd";
import {
  UploadOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
// import "../index.scss";
import { getToken } from "utils/storage";
import "./AssistLication.scss";
import uploadIcon from "../../img/userCenter/icon_upload_img.png";
import cancelIcon from "../../img/userCenter/icon_cancel.png";


const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
const token = getToken();

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }

  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }

  return isJpgOrPng && isLt2M;
};

const uploadProps = {
  maxCount: 1,
  listType: "picture-card",
  name: "file",
  className: "avatar-uploader",
  showUploadList: false,
  action: "/tyjrmh/api/blade-file/fileServer/uploadSingle",
  headers: {
    Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
    "Blade-Auth": getToken(),
  },
  beforeUpload,
};

const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>上传图片</div>
  </div>
);

export default function AssistLication(props) {
  const {
    // state: { isView },
  } = useLocation();
  const routeParmas = useParams()
  const history = useHistory();
  const isView  = false
  const [form] = Form.useForm();
  const [applyStatus, setApplyStatus] = useState(3); //0 未上传 无审核状态     1 审核通过     2 审核中    3  审核失败
  const [applicationFront, setApplicationFront] = useState(''); // 身份证正面 上传的文件列表
  const [applicationOpposite, setApplicationOpposite] = useState(''); // 身份证反面 上传的文件列表
  const [loading, setLoading] = useState(false);
  const [courseInfo, setCourseInfo] = useState([]);

  const name = Form.useWatch("name", form);
  const idCardNum = Form.useWatch("idCardNum", form);
  const age = Form.useWatch("age", form);
  const retiredTime = Form.useWatch("retiredTime", form); //退役时间
  const placement = Form.useWatch("placement", form); //安置地
  const trainingIntention = Form.useWatch("trainingIntention", form); //培训意向
  const failReason = Form.useWatch("fialReason", form); //审核失败原因

  const handleReset = useCallback(() => {
    history.goBack()
  }, []);

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };
  const handleSubmit = () => {
    console.log('courseInfo',courseInfo.id);

    const params = {...form.getFieldsValue(), applicationFront, applicationOpposite ,baseId:courseInfo.id};
    console.log('params',params);
    
    if(!params.applicationName){
      message.error('请输入申请人')
      return
    }
    if(!params.applicationCard){
      message.error('请输入身份证号码')
      return
    }
    if(!params.applicationTel){
      message.error('请输入联系电话')
      return
    }
    Http.post(Request.startBaseApply(), params, (obj) => {
      if (obj.code == 200) {
        message.success("申请成功", 2);
        history.goBack()
      }

    });
    console.log('------handleSubmit------', params);
  };
  const delImg = (type) => {
    switch (type) {
      case "applicationFront":
        setApplicationFront('');
        break;
      case "applicationOpposite":
        setApplicationOpposite('');
        break;
      default:
        break;
    }
  }
    //获取详情
  const getDetail = () =>{
      console.log('id信息',routeParmas);
      let params = {
        id:routeParmas.id
      }
      Http.getApplication(Request.startBaseDetail(),{...params},(obj)=>{
          console.log(obj);
          if(obj.code == 200){
            setCourseInfo(obj.data)
             console.log('obj.data,',obj.data);
            //  form.setFieldsValue(obj.data)
            form.setFieldsValue({baseName:obj.data.epalBaseName,baseBy:obj.data.epalBaseResponsible,baseTel:obj.data.epalBaseTel})
          }
     })
  } 
  useEffect(() => {
    getDetail()
  },[]);

  const handleUpload = useCallback((info, type) => {
    let { file, fileList } = info;
    let imgUrl = '';
    if (file.status === "uploading") {
      setLoading(true);
    }
    if (file.status === "error") {
      message.error("上传失败");
      setLoading(false);
    }
    if (file.status === "done") {
      message.success("上传成功");
      setLoading(false);
      // imgUrl = ImgUrl
      //当图片上传完成，将保存的图片url写入到resData中
      // let resumePhoto = info.file.response.data.url
      // this.setState({ resData: { ...resData, resumePhoto } })
      getBase64(info.file.originFileObj, (url) => {
        console.log('getBase64', url);
        // this.setState({ loading: false, imageUrl: url })
      });

      file.response && file.response.data && (imgUrl = file.response.data.url)
      // fileList = fileList.filter((item) => item.status !== "error");
      // fileList.forEach(item => {
      //   item.response && item.response.data && (item.response.data.url = imgUrl)
      // })
      switch (type) {
        case "applicationFront":
          setApplicationFront(imgUrl);
          break;
        case "applicationOpposite":
          setApplicationOpposite(imgUrl);
          break;
        default:
          break;
      }
    }

  }, []);

  const applyTag = useMemo(() => {
    switch (applyStatus) {
      case 1:
        return (
          <Tag color="#0FC73E" className="apply_train_records_tag tag_pass">
            审核通过
          </Tag>
        );
      case 2:
        return (
          <Tag color="#3356C5" className="apply_train_records_tag tag_loading">
            审核中
          </Tag>
        );
      case 3:
        return (
          <Tag color="#DD0B0B" className="apply_train_records_tag tag_fail">
            审核失败
          </Tag>
        );
      default:
        return <></>;
    }
  }, [applyStatus]);

  return (
    <div className="AssistLication_app">
      <div className="section_center">
        <div className="Base_Detils_Box">
                <span>当前位置：创业帮扶 / 创业基地/ </span>
                <span style={{ color: "#3356C5" }}> 申请入驻创业基地</span>
        </div>
      <Card>
        <div className="ass_section_center">
        <section>
          <div className="form_title">基本信息</div>
          <Form labelAlign={'right'} layout="inline" form={form} className="form_box" colon={false} >
            <Row gutter={[3, 12]}>
              <Col span={24}>
                <Form.Item
                  name="applicationName"
                  required={true}
                  label={
                    <span
                      className={`form_item_label ${
                        isView ? "" : "form_item_label_background"
                      }`}
                    >
                      申请人：
                    </span>
                  }
                >
                  <Input placeholder="请输入姓名" className="form_item_input" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="applicationCard"
                  required={true}
                  label={
                    <span
                      className={`form_item_label ${
                        isView ? "" : "form_item_label_background"
                      }`}
                    >
                      身份证号码：
                    </span>
                  }
                >
                  {isView ? (
                    <span>{idCardNum}</span>
                  ) : (
                    <Input placeholder="请输入身份证号码" className="form_item_input" />
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="applicationTel"
                  required={true}
                  label={
                    <span
                      className={`form_item_label ${
                        isView ? "" : "form_item_label_background"
                      }`}
                    >
                      联系电话：
                    </span>
                  }
                >
                  {isView ? (
                    <span>{age}</span>
                  ) : (
                    <Input placeholder="请输入联系电话" className="form_item_input" />
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="baseName"
                  label={
                    <span
                      className={`form_item_label ${
                        isView ? "" : "form_item_label_background"
                      }`}
                    >
                      基地名称：
                    </span>
                  }
                >
                  {isView ? (
                    <span>{retiredTime}</span>
                  ) : (
                    <Input disabled={true} className="form_item_input" />
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="baseBy"
                  label={
                    <span
                      className={`form_item_label ${
                        isView ? "" : "form_item_label_background"
                      }`}
                    >
                      基地联系人：
                    </span>
                  }
                >
                  {isView ? (
                    <span>{placement}</span>
                  ) : (
                    <Input disabled={true} className="form_item_input" />
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="baseTel"
                  label={
                    <span
                      className={`form_item_label ${
                        isView ? "" : "form_item_label_background"
                      }`}
                    >
                      基地联系电话：
                    </span>
                  }
                >
                  {isView ? (
                    <span>{trainingIntention}</span>
                  ) : (
                    <Input disabled={true} className="form_item_input" />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </section>
        <section>
          <div className="form_title">身份证</div>
          <Form layout="inline" form={form} className="form_box_img" colon={false}>
            <Form.Item label="身份证正面">
              {applicationFront
                ? (
                  <div className="idCard_img">
                    <img src={applicationFront} alt="" />
                    <span className='del_img_btn' onClick={() => delImg('applicationFront')}>
                      <img src={cancelIcon} alt="" />
                    </span>
                  </div>
                )
                : <Upload {...uploadProps} onChange={(info) => { handleUpload(info, "applicationFront"); }}>
                  <div className='upload_materi'>
                    <div className="upload_img">
                      <img src={uploadIcon} alt="" />
                      <span className=''>点击上传</span>
                    </div>
                  </div>
                </Upload>
              }
            </Form.Item>
            <Form.Item label="身份证反面">
              {applicationOpposite
                ? (
                  <div className="idCard_img">
                    <img src={applicationOpposite} alt="" />
                    <span className='del_img_btn' onClick={() => delImg('applicationOpposite')}>
                      <img src={cancelIcon} alt="" />
                    </span>
                  </div>
                )
                : <Upload {...uploadProps} onChange={(info) => { handleUpload(info, "applicationOpposite"); }}>
                  <div className='upload_materi'>
                    <div className="upload_img">
                      <img src={uploadIcon} alt="" />
                      <span className=''>点击上传</span>
                    </div>
                  </div>
                </Upload>
              }
            </Form.Item>
          </Form>
        </section>
        {!isView && applyStatus !== 2 && (
        <div className="form_box_footer">
          <Button type="default" className="btn_reset" onClick={handleReset}>
            返回
          </Button>
          <Button type="primary" className="btn_submit" onClick={handleSubmit}>
            提交
          </Button>
        </div>
      )}
      </div>
      </Card>

      </div>
    </div>
  );
}
